module.exports = __webpack_public_path__ + "static/img/ottawa1.57ca89e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/ottawa1.jpg
// module id = 117
// module chunks = 9